import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, Subject } from 'rxjs';

import { IAlert, AlertType } from '../../shared/models/common';

@Injectable()
export class AlertService {
    private subject = new Subject<IAlert>();
    private keepAfterRouteChange = false;

    constructor(private router: Router) {
        // clear alert messages on route change unless 'keepAfterRouteChange' flag is true
        router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (this.keepAfterRouteChange) {
                    // only keep for a single route change
                    this.keepAfterRouteChange = false;
                } else {
                    // clear alert messages
                    this.clear();
                }
            }
        });
    }

    getAlert(): Observable<any> {
        return this.subject.asObservable();
    }

    success(message: string, keepAfterRouteChange = false, closeInSec?) {
        this.alert(AlertType[AlertType.Success], message, keepAfterRouteChange, closeInSec);
    }

    error(message: string, keepAfterRouteChange = false, closeInSec?) {
        this.alert(AlertType[AlertType.Error], message, keepAfterRouteChange, closeInSec);
    }

    info(message: string, keepAfterRouteChange = false) {
        this.alert(AlertType[AlertType.Info], message, keepAfterRouteChange);
    }

    warn(message: string, keepAfterRouteChange = false, closeInSec?) {
        this.alert(AlertType[AlertType.Warning], message, keepAfterRouteChange, closeInSec);
    }

    alert(alertType: string, message: string, keepAfterRouteChange = false, closeInSec?) {
        this.keepAfterRouteChange = keepAfterRouteChange;
        // this.clear();
        this.subject.next(<IAlert>{ type: alertType, message: message });
        window.scrollTo(0, 0);
        if (alertType !== 'error') {
            // to autoclose after 5 second.
            setTimeout(() => {
                this.clear();
            }, ((closeInSec * 1000) || 5000))
        }
    }

    clear() {
        this.subject.next();
    }
}
